// extracted by mini-css-extract-plugin
export default {"Choice":"📚19-10-2_xYdB","wrapChoices":"📚19-10-2tz72g"};